import React, { useEffect, useState } from "react";
import styles from './TermsAndConditions.module.scss';
import { convertToModule } from "factory/utils/clientUtils";
import { __isCallBackExist } from "factory/modules/HK_service";

const TermsAndCondition = ({ handleCallBack, promotion_name, creative_slot, referData={}, ...props }) => {
    const [pgData, setPgData] = useState(null)
    const [toggle, setToggle] = useState(false)

    const getDidYouKnowData = () => {
        if (props.didYouKnowList && props.didYouKnowList.length > 0) {
            const filterData = props.didYouKnowList.filter(eachData => eachData.nm === 'Terms and conditions')
            if (filterData && filterData.length > 0) {
                setPgData(filterData[0])
            }
        }
    }

    useEffect(() => {
        getDidYouKnowData()
    }, []);

    const handleToggle = () => {
        let creative_name = toggle ? 'collapse' : 'expand';
        let data = {
            promotion_name: promotion_name,
            creative_slot: creative_slot,
            creative_name: creative_name,
            tbAvailablePoints:referData.tbAvailablePoints || 0,
            tbTotalPoints:referData.tbTotalPoints || 0,
            referalPoints:referData.referAndEarnAmountToBeGet ||0
        }
        __isCallBackExist(handleCallBack) && handleCallBack(data)
        setToggle(!toggle)
    }

    return (
        <div className={convertToModule(styles, 'refral-history-cntnr')}>
            <div className={convertToModule(styles, toggle ? 'header-cntnr' : 'header-cntnr-toggled')} onClick={() => (handleToggle())}>
                <div className={convertToModule(styles, 'ttl-sec')}>
                    {
                        pgData && pgData.imageUrl ?
                            <img src={pgData.imageUrl} alt={pgData.imageUrl} className={convertToModule(styles, 'side_img')} />
                            : <></>
                    }
                    {
                        pgData ?
                            <div className={convertToModule(styles, 'ttl')}>
                                {pgData.dis_nm}
                            </div>
                            : <></>
                    }
                </div>

                <div className={convertToModule(styles, 'toggle-sec')}>

                    <svg className={convertToModule(styles, !toggle ? 'toggle-icon-collapsed' : 'toggle-icon')} width="13" height="8" viewBox="0 0 13 8" fill="none">
                        <path d="M11.8882 6.97166L11.4882 7.37167C11.3641 7.49514 11.1962 7.56445 11.0212 7.56445C10.8462 7.56445 10.6783 7.49514 10.5542 7.37167L6.04321 2.86066L1.52721 7.37666C1.40315 7.50014 1.23524 7.56946 1.06021 7.56946C0.885172 7.56946 0.717263 7.50014 0.593205 7.37666L0.193205 6.97666C0.0694867 6.85273 0 6.68477 0 6.50966C0 6.33455 0.0694867 6.16659 0.193205 6.04266L5.57021 0.642662C5.69216 0.513067 5.86036 0.436877 6.03821 0.430664C6.2157 0.437137 6.38349 0.513306 6.50521 0.642662L11.8772 6.02366C12.0015 6.14922 12.0709 6.31897 12.0702 6.49566C12.0729 6.5831 12.0582 6.67022 12.027 6.75194C11.9958 6.83365 11.9486 6.90835 11.8882 6.97166Z" fill="#535664" />
                    </svg>
                </div>
            </div>

            {
                toggle ?
                    <div className={convertToModule(styles, 'refral-body')}>
                        {
                            pgData && pgData.attributeArea && pgData.attributeArea.length > 0
                            && pgData.attributeArea.map((eactAttr, index) => {
                                return (
                                    <div className={convertToModule(styles, 'details-cntnr')} key={'usr_' + index}>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M2.03392 6.28623L4.4668 10.4C6.98815 6.46317 9.81913 3.0129 12.3847 1.02236C12.9598 0.491551 13.8444 0.80119 13.2252 1.37623C10.3499 4.33992 8.13824 7.70172 5.88229 12.9656C4.99761 13.5849 3.98022 13.8945 3.49365 13.3195L0.308786 7.61325C-0.133556 6.90551 1.41464 5.26884 2.03392 6.28623Z" fill="#F97C22" />
                                        </svg>
                                        <div className={convertToModule(styles, 'dtl-line')}>
                                            {eactAttr.value}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    : <></>
            }
        </div>
    )

}
export default TermsAndCondition